import * as types from './mutation-types'
import { API_STATES } from '@/helpers'

const mutations = {
  [types.REGISTER_COMPANY_BEGIN](state) {
    state.companyRegistrationState = API_STATES.REQUEST_PENDING
  },
  [types.REGISTER_COMPANY_SUCCESS](state) {
    state.companyRegistrationError = null
    state.companyRegistrationState = API_STATES.REQUEST_SUCCESS     
  },
  [types.REGISTER_COMPANY_ERROR](state, err) {
    state.companyRegistrationError = err
    state.companyRegistrationState = API_STATES.REQUEST_ERROR
  }
}

export default mutations
